import React from 'react';
import Navbar from '../global-components/navbar';
import BlogHeader from '../global-components/Blog-Header';
import BlogContact from '../../utils/blogContact';
import Footer from '../global-components/footer';
import { useParams } from 'react-router-dom';
import BlogDetails from './blog-details';
import BlogPropertices from './blog-properties';
import BlogFaqs from './blogFaq';


const BlogMain = (props) => {
    const { slug } = useParams();
    
    return (
        <div>
            <Navbar />
            <BlogHeader headertitle="Blogs" subheader="Blogs" />
            <BlogDetails slug={slug} /> {/* Pass slug as prop */}
            <BlogPropertices />
            <BlogContact />
            <Footer />
        </div>
    );
}

export default BlogMain;